// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bonus-management-page .dashboard-body {
  padding-bottom: 2rem;
}

.bonus-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
}

.bonus-card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.bonus-card__title {
  margin: 0 0 1rem;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text, #1e293b);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.bonus-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.bonus-form-group {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.bonus-form-group--full {
  grid-column: 1 / -1;
}

.bonus-form-group label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
}

.bonus-form-group input {
  width: 100%;
  padding: 0.65rem 0.8rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.92rem;
  font-family: inherit;
  color: #0f172a;
  background: #fff;
}

.bonus-form-group input:focus {
  outline: none;
  border-color: #0f766e;
}

.bonus-loading {
  padding: 1rem 0.2rem;
  color: #64748b;
}

.bonus-message {
  margin: 1rem 0 0;
  font-size: 0.9rem;
  font-weight: 600;
}

.bonus-message--success {
  color: #166534;
}

.bonus-message--error {
  color: #b91c1c;
}

.bonus-actions {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
}

.bonus-btn-save {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.58rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  cursor: pointer;
  transition: opacity 0.2s;
}

.bonus-btn-save:hover:not(:disabled) {
  opacity: 0.95;
}

.bonus-btn-save:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .bonus-form-grid {
    grid-template-columns: 1fr;
  }

  .bonus-actions {
    justify-content: stretch;
  }

  .bonus-btn-save {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/System/BonusManagementPage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,6DAA6D;EAC7D,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":[".bonus-management-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.bonus-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.4);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n}\n\n.bonus-card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1.25rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.bonus-card__title {\n  margin: 0 0 1rem;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.bonus-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.bonus-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.bonus-form-group--full {\n  grid-column: 1 / -1;\n}\n\n.bonus-form-group label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n.bonus-form-group input {\n  width: 100%;\n  padding: 0.65rem 0.8rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.92rem;\n  font-family: inherit;\n  color: #0f172a;\n  background: #fff;\n}\n\n.bonus-form-group input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.bonus-loading {\n  padding: 1rem 0.2rem;\n  color: #64748b;\n}\n\n.bonus-message {\n  margin: 1rem 0 0;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.bonus-message--success {\n  color: #166534;\n}\n\n.bonus-message--error {\n  color: #b91c1c;\n}\n\n.bonus-actions {\n  margin-top: 1rem;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.bonus-btn-save {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.58rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.bonus-btn-save:hover:not(:disabled) {\n  opacity: 0.95;\n}\n\n.bonus-btn-save:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .bonus-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .bonus-actions {\n    justify-content: stretch;\n  }\n\n  .bonus-btn-save {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
